import React, { useState, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Grid } from '@react-three/drei';
import './App.css';
import Room from './components/Room';
import Furniture from './components/Furniture';
import ControlPanel from './components/ControlPanel';
import CacheManager from './components/CacheManager';
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [roomDimensions, setRoomDimensions] = useState({ length: 10, width: 8, height: 3 });
  const [furniture, setFurniture] = useState([]);
  const [selectedFurniture, setSelectedFurniture] = useState(null);
  const [isAddingFurniture, setIsAddingFurniture] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const addFurniture = (furnitureData) => {
    const newFurniture = {
      id: Date.now(),
      ...furnitureData,
      position: [0, furnitureData.height / 2, 0],
      rotation: [0, 0, 0],
      color: `hsl(${Math.random() * 360}, 70%, 60%)`
    };
    console.log('添加家具:', newFurniture);
    setFurniture([...furniture, newFurniture]);
    setIsAddingFurniture(false);
  };

  const updateFurniturePosition = (id, newPosition) => {
    setFurniture(prev => prev.map(item => 
      item.id === id ? { ...item, position: newPosition } : item
    ));
  };

  const updateFurnitureRotation = (id, newRotation) => {
    setFurniture(prev => prev.map(item => 
      item.id === id ? { ...item, rotation: newRotation } : item
    ));
  };

  const removeFurniture = (id) => {
    setFurniture(prev => prev.filter(item => item.id !== id));
  };

  const restoreLayout = (newRoomDimensions, newFurniture) => {
    setRoomDimensions(newRoomDimensions);
    setFurniture(newFurniture);
    setSelectedFurniture(null);
  };

  const clearCache = () => {
    // 清除当前布局
    setFurniture([]);
    setSelectedFurniture(null);
  };



  const checkCollision = (furnitureId, newPosition) => {
    const currentFurniture = furniture.find(f => f.id === furnitureId);
    if (!currentFurniture) return false;

    return furniture.some(other => {
      if (other.id === furnitureId) return false;
      
      // 简单的AABB碰撞检测
      const dx = Math.abs(newPosition[0] - other.position[0]);
      const dz = Math.abs(newPosition[2] - other.position[2]);
      
      const minDistanceX = (currentFurniture.length + other.length) / 2;
      const minDistanceZ = (currentFurniture.width + other.width) / 2;
      
      return dx < minDistanceX && dz < minDistanceZ;
    });
  };

  return (
    <div className="App">
      <div className="canvas-container">
        <Canvas
          camera={{ position: [15, 10, 15], fov: 60 }}
          shadows
        >
          <ambientLight intensity={0.4} />
          <directionalLight
            position={[10, 10, 5]}
            intensity={1}
            castShadow
            shadow-mapSize-width={2048}
            shadow-mapSize-height={2048}
          />
          
          <Room dimensions={roomDimensions} />
          
          {furniture.map((item) => {
            console.log('渲染家具:', item);
            return (
              <Furniture
                key={item.id}
                {...item}
                isSelected={selectedFurniture === item.id}
                onSelect={() => setSelectedFurniture(item.id)}
                onDeselect={() => setSelectedFurniture(null)}
                onPositionChange={(newPosition) => updateFurniturePosition(item.id, newPosition)}
                onRotationChange={(newRotation) => updateFurnitureRotation(item.id, newRotation)}
                checkCollision={(newPosition) => checkCollision(item.id, newPosition)}
                roomDimensions={roomDimensions}
                onDragStart={() => setIsDragging(true)}
                onDragEnd={() => setIsDragging(false)}
              />
            );
          })}
          
          <Grid
            args={[roomDimensions.length * 2, roomDimensions.width * 2]}
            cellSize={1}
            cellThickness={0.5}
            cellColor="#6f6f6f"
            sectionSize={5}
            sectionThickness={1}
            sectionColor="#9d4b4b"
            fadeDistance={30}
            fadeStrength={1}
            followCamera={false}
            infiniteGrid={true}
          />
          
          <OrbitControls
            enablePan={!isDragging}
            enableZoom={!isDragging}
            enableRotate={!isDragging}
            maxPolarAngle={Math.PI / 2}
            minDistance={5}
            maxDistance={50}
          />
        </Canvas>
      </div>
      
      <ControlPanel
        roomDimensions={roomDimensions}
        onRoomDimensionsChange={setRoomDimensions}
        furniture={furniture}
        onAddFurniture={addFurniture}
        onRemoveFurniture={removeFurniture}
        onRotateFurniture={(id, newRotation) => updateFurnitureRotation(id, newRotation)}
        onDeselect={() => setSelectedFurniture(null)}
        onSelectFurniture={(id) => setSelectedFurniture(id)}
        selectedFurniture={selectedFurniture}
        isAddingFurniture={isAddingFurniture}
        setIsAddingFurniture={setIsAddingFurniture}
        onRestoreLayout={restoreLayout}
        onClearCache={clearCache}
      />

      <Analytics />
    </div>
  );
}

export default App;
